<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title><h1>Data Importer</h1>

          <v-spacer></v-spacer>
          <v-dialog v-model="loading" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Importing data...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn v-if="false">Filters to Implement</v-btn>
        </v-card-title>
        <hr />
        <v-layout wrap align-center>
          <v-btn
              :loading="uploading"
              :disabled="uploading"
              color="blue-grey"
              class="ma-2 white--text"
              @click="onUpload"
            >
              Upload Data File
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <input
              ref="fileChooser"
              accept=".csv"
              type="file"
              style="display: none"
              @change="onFileChange"
            />
          <v-spacer></v-spacer>
          <v-btn
            :disabled="selected.length != 1"
            @click="onImportSelected"
            :loading="loading"
          >
            Import data from the selected file (max 1)
            <v-icon right dark>mdi-upload</v-icon>
          </v-btn>
          <v-flex xs12 sm4 class="pa-2">
            <v-text-field
              append-icon="mdi-magnify"
              label="Quick Filter..."
              single-line
              hide-details
              v-model="search"
              solo
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout fluid>
          <v-flex xs12>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :loading="$apollo.loading && !loading"
              item-key="id"
              show-select
              class="elevation-1"
              v-bind="pagingOptions"
              :search="search"
            >
              <template v-slot:items="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.pricingDate | formatDate }}</td>
                <td>{{ props.item.destinationName }}</td>
                <td>{{ props.item.agentName }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
      <get-more-results
        :first="first" @limitChange="onLimitChange"
        :items="ratesImports"
        :totalItems="totalItems"
        :loading="$apollo.loading"
        :loadMoreEnabled="loadMoreEnabled"
        @loadMore="loadMore('ratesImports')"
      ></get-more-results>
    </v-flex>
    <div v-if="debug">
      <p>load more enabled : {{ loadMoreEnabled }}</p>
    </div>
  </v-layout>
</template>

<script>
import {
  ALL_GTWEB_RATES_SEARCH_QUERY,
  CREATE_RATES_IMPORT_ATTACHMENT,
  SIGNED_URL_QUERY,
} from "../../../../constants/graphql";
import { ListMixin } from "../../../../mixins/ListMixin";
import GetMoreResults from "../../shared/GetMoreResults";
import gql from "graphql-tag";
import { sortByDate } from "../../../../helpers/index";

const IMPORT_GTWEB_RATES_MUTATION = gql`
  mutation importGtwebRates($ratesImports: [ID]!) {
    task: importRates(ratesImports: $ratesImports) {
      id
      status
    }
  }
`;
const IMPORT_STATUS = gql`
  query importStatus($taskId: ID!) {
    importStatus: taskStatus(id: $taskId) {
      status
      notes
    }
  }
`;
export default {
  name: "RatesImporter",
  mixins: [ListMixin],
  components: { GetMoreResults },
  data() {
    return {
      debug: false,
      uploading: false,
      search: "",
      selected: [],
      headers: [
        { text: "File Name", value: "name" },
        { text: "File Type", value: "fileType" },
        { text: "Upload Date", value: "createdAt", sort: sortByDate },
        { text: "Import Date", value: "importedAt", sort: sortByDate },
        { text: "imported By", value: "importedBy" },
      ],
      taskId: null,
      checkStatus: false,
      loading: false,
      expectedRatesColumns: [
        "Supplier Name",
        "Supplier ID",
        "Service Name",
        "Service ID",
        "Date From",
        "Date To",
        "Agent Group ID",
        "Rate Code",
        "Rate Name",
        "Rate Plan",
        "Currency Buy",
        "Currency Sell",
        "Adult Buy",
        "Adult Sell",
        "Child Cost",
        "Child Sell",
        "API",
        "Is Active",
        "Is Exception",
      ],
      expectedRatesColumnsV2: [
        "Supplier Name",
        "Supplier ID",
        "Supplier Code",
        "Service Name",
        "Service ID",
        "Service Code",
        "Date From",
        "Date To",
        "Agent Group ID",
        "Rate Code",
        "Rate Name",
        "Rate Plan",
        "Currency Code",
        "Adult Buy",
        "Adult Sell",
        "Child Cost",
        "Child Sell",
        "Markup",
        "Min Pax",
        "Max Pax",
        "Min Stay",
        "Max Stay",
        "API",
        "Is Exception",
        "Business Model",
        "Supplier Commission",
        "Remarks",
      ],
      // Per-day-of-week variant of the v2 rates sheet (Redmine #11260). Same
      // layout as v2 but the four price columns are expanded into seven Mon..Sun
      // blocks so a rate can differ by weekday. 51 columns total (50 before #11525).
      expectedRatesColumnsAllDays: [
        "Supplier Name",
        "Supplier ID",
        "Supplier Code",
        "Service Name",
        "Service ID",
        "Service Code",
        "Date From",
        "Date To",
        "Agent Group ID",
        "Rate Code",
        "Rate Name",
        "Rate Plan",
        "Currency Code",
        "Mon Adult Buy", "Mon Adult Sell", "Mon Child Cost", "Mon Child Sell",
        "Tue Adult Buy", "Tue Adult Sell", "Tue Child Cost", "Tue Child Sell",
        "Wed Adult Buy", "Wed Adult Sell", "Wed Child Cost", "Wed Child Sell",
        "Thu Adult Buy", "Thu Adult Sell", "Thu Child Cost", "Thu Child Sell",
        "Fri Adult Buy", "Fri Adult Sell", "Fri Child Cost", "Fri Child Sell",
        "Sat Adult Buy", "Sat Adult Sell", "Sat Child Cost", "Sat Child Sell",
        "Sun Adult Buy", "Sun Adult Sell", "Sun Child Cost", "Sun Child Sell",
        "Markup",
        "Min Pax",
        "Max Pax",
        "Min Stay",
        "Max Stay",
        "API",
        "Is Exception",
        "Business Model",
        "Supplier Commission",
        "Remarks",
      ],
      expectedFlightsColumns: [
        "Supplier ID",
        "Flight No",
        "Flight Type",
        "Valid From",
        "Valid To",
        "Departure Point",
        "Departure Time",
        "Arrival Point",
        "Arrival Time",
        "Is Exception",
        "Week Days",
      ],
      expectedFlightsColumnsV2: [
        "Supplier ID",
        "Supplier Code",
        "Flight No",
        "Flight Type",
        "Valid From",
        "Valid To",
        "Departure Point",
        "Departure Time",
        "Arrival Point",
        "Arrival Time",
        "Is Exception",
        "Week Days",
      ],
      expectedServicesColumns: [
        "supplier_name",
        "supplier_code",
        "supplier_id",
        "service_type_name",
        "service_name",
        "service_code",
        "std_occupancy",
        "min_occupancy",
        "max_occupancy",
        "sales_nominal_code",
        "purchase_nominal_code",
        "tax_code",
        "not_in_use",
        "no_report",
        "skip_markup",
        "skip_circuit_discount",
      ],
      expectedServicesColumnsV2: [
        "supplier_name",
        "supplier_code",
        "supplier_id",
        "service_type_name",
        "service_name",
        "service_alternative_name",
        "service_code",
        "std_occupancy",
        "min_occupancy",
        "max_occupancy",
        "tax_code",
        "not_in_use",
        "no_report",
        "skip_markup",
        "skip_circuit_discount",
        "skip_agent_commission",
        "no_voucher",
      ],
      expectedSuppliersColumns: [
        "account_code",
        "name",
        "address",
        "service_type",
        "telephone",
        "fax",
        "email",
        "email2",
        "code",
        "region",
        "head_office_name",
        "head_office_code",
        "account_short_code",
        "purchase_nominal_code",
        "sales_nominal_code",
        "currency_code",
        "destination_name",
        "not_in_use",
      ],
      expectedSuppliersColumnsV2: [
        "account_code",
        "name",
        "alternative_name",
        "address",
        "supplier_type",
        "supplier_service_type",
        "telephone",
        "email",
        "email2",
        "code",
        "region",
        "head_office_name",
        "head_office_code",
        "purchase_nominal_code",
        "sales_nominal_code",
        "currency_code",
        "destination_name",
        "language_code",
        "rate_type_code",
        "rating",
        "board_basis",
        "website",
        "accounts_email",
        "payee_name",
        "not_in_use",
        "no_voucher",
        "no_letter",
      ],
      expectedExtrasColumns: [
        "Supplier Name",
        "Supplier Code",
        "Supplier Id",
        "Service Name",
        "Service Code",
        "Service ID",
        "Extra Type",
        "Extra Name",
        "Date From",
        "Date To",
        "Agent Group ID",
        "Rate Code",
        "Rate Name",
        "Currency",
        "Cost",
        "Sell",
        "Price Percent",
        "Tax Code",
        "Child Only",
        "Infant Only",
        "Markup",
        "Discount",
        "Mandatory",
        "No Report",
        "Commission",
        "Capacity Change",
        "Percent From Child Price",
        "No Voucher",
        "Markup Percentage"
      ],
      expectedAgentsColumns: [
        "Agent ID",
        "Agent Name",
        "Company Code",
        "Email",
        "Telephone",
        "Language",
        "Department",
        "Agent Type",
        "Address",
        "City",
        "Region",
        "State",
        "Zip Code",
        "Not in Use",
        "Round Markups",
        "Round Discounts",
        "Notes",
        "Currency",
        "Tax Code",
        "Account Code",
        "Accounts Department Code",
        "Transport Markup",
        "Accommodation Markup",
        "Activity Markup",
        "Other Services Markup",
        "Travel Markup",
        "Package Markup",
        "Transport Commission",
        "Accommodation Commission",
        "Activity Commission",
        "Other Services Commission",
        "Travel Commission",
        "Package Commission",
        "Charge Commission"
      ],
      expectedClientsColumns: [
        "Client Title",
        "Name",
        "Surname",
        "Code",
        "Client Type",
        "Client Status",
        "Telephone",
        "Mobile",
        "Email",
        "Language",
        "Nationality",
        "Date of Birth",
        "Address",
        "City",
        "State",
        "Zip Code",
        "Notes"
      ],
      expectedAllocationsColumns: [
        "Supplier_Name",
        "Supplier_ID",
        "Supplier_Code",
        "Service_Name",
        "Service_ID",
        "Service_Code",
        "Allocation_Name",
        "Date_From",
        "Date_To",
        "Agent_Group_ID",
        "Type",
        "Release",
        "Mon",
        "Tue",
        "Wed",
        "Thur",
        "Fri",
        "Sat",
        "Sun"
      ]
    };
  },
  computed: {
    fbToken() {
      return this.gtRoutesFbToken ? this.gtRoutesFbToken : "notoken";
    },
    items() {
      return this.ratesImports
        ? this.ratesImports.edges.map((item) => ({ ...item.node }))
        : [];
    },
    selectedRates() {
      return this.selected.map((i) => i.id);
    },
  },
  methods: {
    onReloadList() {
      if (this.$apollo.queries.ratesImports != null) {
        this.load = true;
        this.$apollo.queries.ratesImports.refetch();
      }
    },
    handleAttachmentFinish(response) {
      this.onReloadList();
      this.$store.dispatch("showAppSnackbar", {
        msg: "Attachment added",
        color: "success",
      });
      this.uploading = false;
    },
    addRatesFile(response) {
      this.$apollo
        .mutate({
          mutation: CREATE_RATES_IMPORT_ATTACHMENT,
          variables: {
            input: {
              url: response.url,
            },
          },
        })
        .then(this.handleAttachmentFinish, this.handleAttachmentError);
    },
    putAttachmentToTheBucket(result) {
      const response = { ...result.data.signedUrl };
      if (response.url) {
        fetch(response.url, {
          method: "PUT",
          body: this.selectedAttachment,
        }).then(this.addRatesFile, this.handleAttachmentError);
      } else {
        this.handleAttachmentError({ message: "Cannot upload the file!" });
      }
    },
    handleAttachmentError(error) {
      this.uploading = false;
      this.$store.dispatch("showAppSnackbar", {
        msg: error.message,
        color: "danger",
      });
    },
    onUpload() {
      this.$refs.fileChooser.click();
    },
    async validateRatesFile(file, expectedColumns, name) {
      const vaidatorPromise = new Promise((resolve, reject) => {
        const reader = new FileReader();
        let error = "";
        reader.addEventListener("load", () => {
          const csv = reader.result;
          const lines = csv.replace("\r", "").split("\n");
          const headers = lines[0].split(",");
          if (name == "Suppliers") {
            console.log(headers, expectedColumns);
          }
          // #11525: Remarks (rates) and Markup Percentage (extras) are
          // optional trailing columns, so sheets without them still validate.
          const optionalTrailing = ["Remarks", "Markup Percentage"];
          const oldWidthOk =
            optionalTrailing.includes(expectedColumns[expectedColumns.length - 1]) &&
            headers.length === expectedColumns.length - 1;
          if (headers.length !== expectedColumns.length && !oldWidthOk) {
            error =
              "Invalid " +
              name +
              " file format - wrong number of columns, expected: " +
              expectedColumns.length +
              ", found: " +
              headers.length +
              "!";
            resolve([false, error]);
          }
          // Normalize so "_" and " " are treated as equivalent separators
          // (sample sheets mix "Charge Commission" / "Charge_Commission" styles)
          const normalize = (s) =>
            s.toString().toLowerCase().trim().replace(/_/g, " ");
          for (let i = 0; i < headers.length; i++) {
            if (
              expectedColumns[i] === undefined ||
              normalize(headers[i]) !== normalize(expectedColumns[i])
            ) {
              error =
                "Invalid " +
                name +
                " file format - wrong column name at position " +
                i +
                ", expected: '" +
                expectedColumns[i] +
                "', found: '" +
                headers[i] +
                "'!";
              resolve([false, error]);
            }
          }
          resolve([true, ""]);
        });
        reader.readAsText(file);
      });
      return vaidatorPromise;
    },
    uploadFile(file) {
      this.uploading = true;
      this.selectedAttachment = file;
      this.$apollo
        .query({
          query: SIGNED_URL_QUERY,
          variables: {
            fileName: this.selectedAttachment.name,
          },
        })
        .then(this.putAttachmentToTheBucket, this.handleAttachmentError);
    },
    async onFileChange(event) {
      let valid = false;
      let errors = { Flights: [], FlightsV2: [], Rates: [], Suppliers: [], Services: [], RatesV2: [], RatesAllDays: [], SuppliersV2: [], ServicesV2: [], Extras: [], Agents: [], Clients: [], Allocations: []};
      const validators = {
        Rates: this.expectedRatesColumns,
        RatesV2: this.expectedRatesColumnsV2,
        RatesAllDays: this.expectedRatesColumnsAllDays,
        Flights: this.expectedFlightsColumns,
        FlightsV2: this.expectedFlightsColumnsV2,
        Suppliers: this.expectedSuppliersColumns,
        SuppliersV2: this.expectedSuppliersColumnsV2,
        Services: this.expectedServicesColumns,
        ServicesV2: this.expectedServicesColumnsV2,
        Extras: this.expectedExtrasColumns,
        Agents: this.expectedAgentsColumns,
        Clients: this.expectedClientsColumns,
        Allocations: this.expectedAllocationsColumns
      };
      if (this.$refs.fileChooser.files.length > 0) {
        let error = "";
        const file = this.$refs.fileChooser.files[0];
        //iterate validators
        for (let key in validators) {
          [valid, error] = await this.validateRatesFile(
            file,
            validators[key],
            key
          );
          if (!valid) {
            errors[key].push(error);
          }
        }
        console.log(errors["FlightsV2"]);
        if (
          errors["Rates"].length > 0 &&
          errors["RatesV2"].length > 0 &&
          errors["RatesAllDays"].length > 0 &&
          errors["Flights"].length > 0 &&
          errors["FlightsV2"].length > 0 &&
          errors["Suppliers"].length > 0 &&
          errors["SuppliersV2"].length > 0 &&
          errors["Services"].length > 0 &&
          errors["ServicesV2"].length > 0 &&
          errors["Extras"].length > 0 &&
          errors["Agents"].length > 0 &&
          errors["Clients"].length > 0 &&
          errors["Allocations"].length > 0
        ) {
          this.$store.dispatch("showAppSnackbar", {
            msg: errors["Rates"]
              .concat(errors["RatesV2"])
              .concat(errors["RatesAllDays"])
              .concat(errors["Flights"])
              .concat(errors["FlightsV2"])
              .concat(errors["Suppliers"])
              .concat(errors["SuppliersV2"])
              .concat(errors["Services"])
              .concat(errors["ServicesV2"])
              .concat(errors["Extras"])
              .concat(errors["Agents"])
              .concat(errors["Clients"])
              .concat(errors["Allocations"])
              .join("\n"),
            color: "danger",
          });
          return;
        }
        this.uploadFile(file);
      }
    },
    async onImportSelected(e) {
      try {
        this.loading = true;
        const data = await this.$apollo.mutate({
          mutation: IMPORT_GTWEB_RATES_MUTATION,
          variables: {
            ratesImports: this.selectedRates,
          },
        });
        this.taskId = data.data.task.id;
        this.checkStatus = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  apollo: {
    ratesImports: {
      query: ALL_GTWEB_RATES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams,
        };
      },
      result({ data, loader, networkStatus }) {
        this.totalItems = data.ratesImports.totalCount;
      },
      fetchPolicy: "network-only",
    },
    importStatus: {
      query: IMPORT_STATUS,
      variables() {
        return { taskId: this.taskId };
      },
      result({ data, loader, networkStatus }) {
        this.checkStatus = false;
        const status = data.importStatus.status;
        if (status == "IN_PROGRESS") {
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else {
          const notes = data.importStatus.notes || "";
          // "error"/"warning" snackbars stay up until closed (see AppSnackbar)
          let color = "success";
          if (status == "ERROR") {
            console.error(notes);
            color = "error";
          } else if (/not found|Skipping|invalid rows omitted/i.test(notes)) {
            color = "warning";
          }
          this.$store.dispatch("showAppSnackbar", {
            msg: notes,
            color,
          });
          this.loading = false;
          this.checkStatus = false;
          this.onReloadList();
        }
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/rates-importer/RatesImporter.vue